import styled from 'styled-components';

import PropertyList from './PropertyList';

const StyledPropertyList = styled(PropertyList)`
    .heading-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .image-map-trigger-container {
        width: 235px;
    }

    .map-trigger {
        width: auto !important;
    }

    .image-map-trigger {
        background-image: url('/assets/img/maps.png');
        background-repeat: no-repeat;
        background-size: cover;
        padding-top: 59.75%;
        position: relative;
        cursor: pointer;
        border-radius: ${(props) => props.theme.corners.box.inside}px;

        .trigger {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .map-container {
        padding-top: 75%;
        border-radius: ${(props) => props.theme.corners.box.inbetween}px;
        overflow: hidden;
        position: relative;
        margin-bottom: 20px;
    }
`;

export default StyledPropertyList;
